module.exports = "/_next/static/videos/teaser2-slice-1-5a504870f4b49c5b885bc2e30c9b6e17.mp4";